import React from "react";
import {useAccount} from "../administration/users/AccountProvider";
import {Grid} from "@mui/material";
import {ApplicationCard} from "./ApplicationCard";
import {getVisibleApplicationRoles} from "../administration/users/ApplicationRoles";

export function SolutionsPage() {
  const account = useAccount();

  return (
    <div>
      <Grid container={true} sx={{marginTop: 1}} spacing={1}>
        {getVisibleApplicationRoles(account).map(applicationRole =>
          <Grid key={applicationRole.applicationName} item={true} xs={12} sm={6} lg={4} xl={2}>
            <ApplicationCard applicationName={applicationRole.applicationName} role={applicationRole.role}/>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
